import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollLocationState {
	preserveScroll?: boolean;
}

function useScrollManagement() {
	const { pathname, hash, state } = useLocation();

	useEffect(() => {
		if ((state as ScrollLocationState | null)?.preserveScroll) return;

		if (hash) {
			const element = document.getElementById(hash.substring(1));
			if (element) {
				element.scrollIntoView({ behavior: 'smooth' });
			}
		} else {
			window.scrollTo(0, 0);
		}
	}, [pathname, hash, state]);
}

export { useScrollManagement };
